import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Navbar } from "@/components/findx/Navbar";
import { Footer } from "@/components/findx/Footer";
import { Landing } from "@/components/findx/Landing";
import { Opportunities } from "@/components/findx/Opportunities";
import { PostSomething } from "@/components/findx/PostSomething";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (!window.location.hash) window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    document.title = "FINDXCHANGE — Find. Connect. Grow.";
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="bg-[#05070B] text-slate-200 min-h-screen" data-testid="findxchange-app">
        <Navbar />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/opportunities" element={<Opportunities />} />
          <Route path="/post" element={<PostSomething />} />
        </Routes>
        <Footer />
        <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#0A0D14", border: "1px solid rgba(0,240,255,0.3)", color: "#F1F5F9", borderRadius: 0, fontFamily: "'Chivo Mono', monospace", fontSize: "12px", letterSpacing: "0.08em" } }} />
      </div>
    </BrowserRouter>
  );
}

export default App;
